// This file is automatically generated. Do not edit manually.

import { EmailTemplate } from "src/api/generated/erp/db/types/tables/emailTemplate";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace EmailTemplateQueryApi {
	export async function getEmailTemplateOptions(): Promise<Array<EmailTemplate>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/common/mail/emailTemplate/query/getEmailTemplateOptions",
			method: "POST",
			data: {},
		});
		return response as Array<EmailTemplate>;
	}
}
